import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from '@prophecy/theme';
import { createPlatePlugin, useEditorRef } from '@udecode/plate/react';
import styled from 'styled-components';
import { Badges } from '../Badges';
import { Stack } from '../Layout';
import { useMarkdownProps } from './context';
import { InsertImageButton } from './InsertImageButton';
import { LinkButton } from './LinkPlugin';
import { OrderedListButton, UnorderedListButton } from './List';
import { StyledFixedToolbar } from './styled';
import { TableActions } from './TableActions';
import { TextTypeSelect } from './TextTypeSelect';
import { BoldButton, UnderlineButton, ItalicButton, CodeBlockButton } from './ToolbarComponents';
import { PluginType } from './types';
const VerticalSeparator = styled.hr `
  background-color: ${theme.colors.gray300};
  border: none;
  box-shadow: none;
  height: ${theme.spaces.x24};
  width: ${theme.spaces.x1};
`;
const ToolbarActions = styled(Stack) `
  ${({ $disabled }) => $disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  `}
`;
const ReadOnlyBadge = styled(Badges) `
  height: auto;
  line-height: 1.1;
  max-height: 90%;
`;
function FixedToolbar() {
    const { customTools, supportedPluginTypes, readOnly } = useMarkdownProps();
    const editor = useEditorRef();
    const renderedCustomTools = typeof customTools === 'function' ? customTools(editor) : customTools;
    return (_jsxs(StyledFixedToolbar, { direction: 'horizontal', alignY: 'center', align: 'space-between', children: [_jsxs(ToolbarActions, { direction: 'horizontal', gap: theme.spaces.x4, alignY: 'center', "$disabled": readOnly, children: [supportedPluginTypes.has(PluginType.TextType) && _jsx(TextTypeSelect, {}), supportedPluginTypes.has(PluginType.Bold) && _jsx(BoldButton, {}), supportedPluginTypes.has(PluginType.Italic) && _jsx(ItalicButton, {}), supportedPluginTypes.has(PluginType.Underline) && _jsx(UnderlineButton, {}), supportedPluginTypes.has(PluginType.Link) && _jsx(LinkButton, {}), supportedPluginTypes.has(PluginType.Code) && _jsx(CodeBlockButton, {}), supportedPluginTypes.has(PluginType.Image) && _jsx(InsertImageButton, {}), supportedPluginTypes.has(PluginType.List) && _jsx(UnorderedListButton, {}), supportedPluginTypes.has(PluginType.List) && _jsx(OrderedListButton, {}), supportedPluginTypes.has(PluginType.Table) && _jsx(TableActions, {}), renderedCustomTools && (_jsxs(_Fragment, { children: [_jsx(VerticalSeparator, {}), renderedCustomTools] }))] }), readOnly && (_jsx(ReadOnlyBadge, { size: 's', tone: 'yellow', children: "Read only" }))] }));
}
export const FixedToolbarPlugin = createPlatePlugin({
    key: 'fixed-toolbar',
    render: {
        beforeEditable: () => _jsx(FixedToolbar, {})
    }
});
